import { FC, Fragment } from 'react';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';
import CountUp from 'react-countup';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';

const CCDHThingsToDo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	const data = [
		{
			title: 'Assign CCA',
			count: counts?.assignCca ?? 0,
			link: 'CCDHAssignCCAListPage',
		},
		{
			title: 'Analisa SLIK & Name Clearance',
			count: counts?.creditApproval ?? 0,
			link: 'CCDHAnalisaSLIKListPage',
		},
		{
			title: 'Survey Approval',
			count: counts?.surveyApproval ?? 0,
			link: 'CCDHSurveyApprovalListPage',
		},
		{
			title: 'Verifikasi Laporan Kunjungan',
			count: counts?.visitReport ?? 0,
			link: 'CCDHVisitReportListPage',
		},
		{
			title: 'Pipeline Hot Prospect',
			count: counts?.pipelineHotProspect ?? 0,
			link: 'CCDHPipelineListPage',
		},
		{
			title: 'Monitoring Pipeline Golive',
			count: counts?.pipelineGoLive ?? 0,
			link: 'GoliveListPage',
		},
		{
			title: 'Nota Analisa Pembiayaan',
			count: counts?.nap ?? 0,
			link: 'NAPListPage',
		},
		{
			title: 'Pemberitahuan Fasilitas',
			count: counts?.spf ?? 0,
			link: 'SPFListPage',
		},
		{
			title: 'Memo Pencairan Pembiayaan',
			count: counts?.mpp ?? 0,
			link: 'MPPListPage',
		},
	];

	return (
		<Fragment>
			<List
				loading={isLoading}
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default CCDHThingsToDo;
